import Vue from 'vue';
import moment from 'moment';

function dateFormat(value, date) {
    date = date || 'YYYY-MM-DD HH:mm:ss';
    return moment(value).format(date);
}

Vue.prototype.$dateFormat = dateFormat;
Vue.filter('moment', dateFormat);

export default  dateFormat;
